import { useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux"

import { Button } from "../DesignSystem"

import "./index.scss"

function Snackbar() {
  const dispatch = useDispatch()
  const {
    snackbar: { message, options },
  } = useSelector((state) => state.app)
  const [show, setShow] = useState(false)
  const [currentMessage, setCurrentMessage] = useState("")

  useEffect(() => {
    if(options.closeSnackbar) {
      setShow(false)
    }
  }, [options.closeSnackbar])

  useEffect(() => {
    let timer
    const close = () => {
      setShow(false)
      dispatch({ type: "CHANGE_SNACKBAR", payload: { message: "" } })
    }

    if (message === "") {
      setShow(false)
      setTimeout(() => setCurrentMessage(message), 200)
    } else if (message !== currentMessage) {
      setShow(false)
      setTimeout(() => setCurrentMessage(message), 200)
      setTimeout(() => setShow(true), 200)
      if(options.time !== -1) {
        timer = setTimeout(close, options.time)
      }
    } else {
      setCurrentMessage(message)
      close()
    }

    return () => {
      clearTimeout(timer)
    }

    // eslint-disable-next-line
  }, [dispatch, message, options])

  function handleClickClose() {
    dispatch({ type: "CHANGE_SNACKBAR", payload: { message: "" } })
  }

  function handleClickUndo() {
    options.undoAction && options.undoAction()
  }

  function handleCallback() {
    options.handleCallback && options.handleCallback()
  }

  function renderActions() {
    if (options.showUndo || options.showClose || options.showCallback)
      return (
        <div className="snackbar__actions">
          {options.showUndo && (
            <Button size="small" onClick={handleClickUndo}>
              Desfazer
            </Button>
          )}
          {options.showCallback && (
            <Button size="small" onClick={handleCallback}>
              {options.callbackMessage}
            </Button>
          )}
          {options.showClose && (
            <Button size="small" onClick={handleClickClose} icon="X" />
          )}
        </div>
      )
    else return null
  }

  return (
    <div
      className={show ? "snackbar snackbar--visible" : "snackbar"}
      style={{ backgroundColor: options.bgColor }}
    >
      <span style={{ color: options.colorText ?? "#fff" }}>
        {options.title && <p>{options.title}</p>}
        {currentMessage}
      </span>
      {renderActions()}
    </div>
  )
}

export default Snackbar
